import { render, staticRenderFns } from "./OnlineBooking.vue?vue&type=template&id=21d219f2&scoped=true&"
import script from "./OnlineBooking.vue?vue&type=script&lang=js&"
export * from "./OnlineBooking.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBooking.vue?vue&type=style&index=0&id=21d219f2&scoped=true&lang=scss&"
import style1 from "./OnlineBooking.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d219f2",
  null
  
)

export default component.exports